import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AppStore {
  isLoading: boolean;
  error?: string;
  setError: (error: string | undefined) => void;
  clearError: () => void;
}

export const useAppStore = create<AppStore>()(
  devtools(
    (set) => ({
      isLoading: false,
      error: undefined,

      setError: (error: string | undefined) => {
        set({ error });
      },

      clearError: () => {
        set({ error: undefined });
      },
    }),
    {
      name: "hyperamm-store",
    },
  ),
);
